export default {
  title: 'light',

  colors: {
    background: '#f0f0f5',
    text: '#3a3a3a',
    repoBackground: '#fff',
  },
};
